import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import swal from 'sweetalert2'
import { stringify } from 'qs'
import { API_ENDPOINT_BASE } from './constans'

Vue.use(Vuex)

var storage = localStorage.getItem('user');

export default new Vuex.Store({
	state: {
		user: storage ? JSON.parse(storage) : null,
		loading: null,
		financing: []
	},
	mutations: {
		RESET(state) {
			state.departure = null
		},
		LOADING(state, payload) {
			state.loading = !!payload;
		},
		LOGIN_SUCCESS(state, { user, msg }) {
			state.user = user
			localStorage.setItem('user', JSON.stringify(user))
			swal.fire(msg, '','success')
		},
		LOGOUT_SUCCESS(state) {
			state.user = null
			localStorage.removeItem('user')
			window.location.reload()
		},
		USER_ERROR(state) {
			state.user = null
			localStorage.removeItem('user')
			window.location.reload()
		},
		SET_FINANCING(state, data) {
			state.financing = data || []
		},
		FINANCING_ERROR(state) {
			state.financing = []
		}
	},
	actions: {
		LOGIN({ commit }, data) {
			commit('LOADING', true);
			return new Promise((resolve, reject) => {
				axios.post(API_ENDPOINT_BASE + '/payments/backend/login', stringify(data))
				.then( response => {
					commit('LOGIN_SUCCESS', response.data)
					resolve(response)
				})
				.catch(error => {
					commit('LOGIN_ERROR', error)
					reject(error)
				})
				.finally(() => commit('LOADING', false))
			})
		},
		LOGOUT({ commit }, data) {
			commit('LOADING', true);
			axios.post(API_ENDPOINT_BASE + '/payments/backend/logout', stringify(data))
			.then(() => commit('LOGOUT_SUCCESS'))
			.catch(error => commit('USER_ERROR', error))
		},
		FINANCING({ commit }) {
			commit('LOADING', true);
			return new Promise((resolve, reject) => {
				axios.get(API_ENDPOINT_BASE + '/payments/backend/financing.json')
				.then( response => {
					commit('SET_FINANCING', response.data)
					resolve(response)
				})
				.catch(error => {
					commit('FINANCING_ERROR')
					swal.fire(error.response.data.msg, '','error').then(reject)
				})
				.finally(() => commit('LOADING', false))
			})
		}
	}
})